
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"15","height":"13","viewBox":"0 0 15 13","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.086 12.039c-.072-.071-.382-.338-.637-.586C3.845 9.996 1.22 6.197.419 4.209.29 3.906.018 3.143 0 2.734c0-.39.09-.763.273-1.12a2.342 2.342 0 011.13-.993c.328-.125 1.312-.32 1.33-.32C3.808.107 5.558 0 7.49 0c1.841 0 3.519.107 4.611.267.018.018 1.24.213 1.659.426.765.39 1.24 1.154 1.24 1.971v.071c-.019.532-.494 1.651-.511 1.651-.803 1.882-3.299 5.593-4.958 7.085 0 0-.426.42-.692.603a2.229 2.229 0 01-1.33.426c-.529 0-1.022-.16-1.423-.461z"}})])
          )
        }
      }
    